import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

import CoachingToDo from '../../../components/CoachingToDo/CoachingToDo';
import CoachingShoutOut from '../../../components/coachingShoutOut/coachingShoutOUt';
import { CoreValueDropdown } from '../../../components/coreValueDropdown/CoreValueDropdown';
import { DeleteCoachingDialog } from '../../../components/deleteCoaching/DeleteCoachingDialog';
import { useDeleteCoachingMutation } from '../coachingSlice';
import { transformDataUpdateMetricForm } from './data-adapter';
import { useGetCoachingMetricGoalQuery, useUpdateCoachingMetricsMutation } from './metricsSlice';
import { selectCurrentEmpid, selectIsUseCoachingSkills } from '../../../pages/login/authSlice';
import { SkillBehaviorDropdown } from '../../../components/skillBehaviorDropdown/SkillBehaviorDropdown';
import { monthNames } from '../../../utils/typeConstants';
import './MetricGoal.scss';
import DescriptionBox from '../../../components/descriptionBox/DescriptionBox';

interface MetricGoalProps {
    recipientId: string;
    coachingScorecardId: number;
    metricId: number;
    showTLCpmment: boolean;
    showAddGoal: boolean;
    saveClicked: boolean;
    receiverName: string;
    toDoVisible: boolean;
    setToDoVisible: React.Dispatch<React.SetStateAction<boolean>>;
    coreValueId: number;
    shoutoutVisible: boolean;
    setShoutoutVisible: React.Dispatch<React.SetStateAction<boolean>>;
    setShowAddGoal: (e: boolean) => void;
    setShowTLCpmment: (e: boolean) => void;
    setSaveClicked: (e: boolean) => void;
    handleCoreId: (coreId: number) => void;
    formChanged: (event: boolean) => void;
    metricName?: string;
    inputMonth?: number;
    inputYear?: number;
}

const MetricGoal = (props: MetricGoalProps) => {
    const [goalCreationDate, setGoalCreationDate] = useState(new Date());
    const [coreValue, setCoreValue] = useState<number>(0);
    const [requestMetric, setRequestMetric] = useState<any>([]);
    const [UpdateMetric] = useUpdateCoachingMetricsMutation();
    const [DeleteCoaching] = useDeleteCoachingMutation();
    const [coachingMetricId, setCoachingMetricId] = useState<number>(0);
    const [showToDoButton, setShowToDoButton] = useState<boolean>(false);
    const [showShoutOutButton, setShowShoutOutButton] = useState<boolean>(false);
    const [diaDelete, setDiaDelete] = useState<boolean>(false);
    const currEmpId = useSelector(selectCurrentEmpid);

    const [skill, setSkill] = useState(0);
    const [behavior, setBehavior] = useState(0);
    const isUseCoachingSkills = useSelector(selectIsUseCoachingSkills);
    const [skillName, setSkillName] = useState('');
    const [behaviorName, setBehaviorName] = useState('');
    const [todoTitle, setTodoTitle] = useState('');

    const { data: coachingMetricGoal } = useGetCoachingMetricGoalQuery(
        {
            employeeNumber: props?.recipientId,
            coachingScorecardId: props?.coachingScorecardId,
            metricId: props?.metricId,
        },
        { skip: !props?.recipientId || !props?.coachingScorecardId || !props?.metricId }
    );

    useEffect(() => {
        if (coreValue > 0) {
            const updatedRequestMetric = [...requestMetric];
            if (updatedRequestMetric[0].coreValueId !== coreValue) {
                props.formChanged(true);
            }
            updatedRequestMetric[0].coreValueId = coreValue;
            setRequestMetric(updatedRequestMetric);
        }

        if (skill > 0) {
            const updatedRequestMetric = [...requestMetric];
            if (updatedRequestMetric[0].CoachingSkillId !== skill) {
                props.formChanged(true);
            }
            updatedRequestMetric[0].CoachingSkillId = skill;
            setRequestMetric(updatedRequestMetric);
        }

        if (behavior > 0) {
            const updatedRequestMetric = [...requestMetric];
            if (updatedRequestMetric[0].CoachingBehaviorId !== behavior) {
                props.formChanged(true);
            }
            updatedRequestMetric[0].CoachingBehaviorId = behavior;
            setRequestMetric(updatedRequestMetric);
        }
        let todoTitle = `${props?.metricName} -`;
        setShowToDoButton(false);
        if (isUseCoachingSkills === false) {
            setShowToDoButton(true);
        } else if (isUseCoachingSkills === true && skill > 0 && behavior > 0) {
            setShowToDoButton(true);
            todoTitle += ` ${skillName} - ${behaviorName} -`;
        }
        const month = props?.inputMonth !== undefined ? monthNames[props?.inputMonth] : '';
        const year = props?.inputYear !== undefined ? props?.inputYear : '';
        todoTitle += ` ${month} ${year}`;
        setTodoTitle(todoTitle);
    }, [coreValue, skill, behavior, isUseCoachingSkills, skillName, behaviorName]);

    useEffect(() => {
        if (props.saveClicked) {
            handleSave();
        }
    }, [props.saveClicked]);

    const handleSave = () => {
        props.setSaveClicked(false);
        // if (!validate()) return; no validations needed
        const currDate = new Date();
        if (!requestMetric[0].authorCommentDate || requestMetric[0].authorCommentDate === '') {
            requestMetric[0].authorCommentDate = `${currDate.getFullYear()}-${
                currDate.getMonth() + 1
            }-${currDate.getDate()}`;
        }

        if (coachingMetricGoal?.data[0]?.goal_create_date) {
            requestMetric[0].goalCreateDate = coachingMetricGoal?.data[0]?.goal_create_date;
        } else if (!coachingMetricGoal?.data[0]?.goal_create_date && requestMetric[0]?.goalComment) {
            requestMetric[0].goalCreateDate = `${currDate.getFullYear()}-${
                currDate.getMonth() + 1
            }-${currDate.getDate()}`;
        } else {
            requestMetric[0].goalCreateDate = undefined;
        }
        if (requestMetric[0]?.goalComment.trim().length > 0) {
            requestMetric[0].goalEmployeeNumber = currEmpId;
        }

        if (isUseCoachingSkills === false) {
            requestMetric[0].CoachingSkillId = null;
            requestMetric[0].CoachingBehaviorId = null;
        } else if (isUseCoachingSkills === true) {
            requestMetric[0].coreValueId = null;
        }

        const request = requestMetric[0];
        UpdateMetric(request)
        .unwrap()
        .then((res: any) => {
            if (res?.data) {
                toast.success('Metric saved successfully');
                props.formChanged(false);
            } else toast.error('Something went wrong');
        })
        .catch((error: any) => {
            toast.error(error);
        });
    };

    const deleteIconClicked = () => {
        if (coachingMetricGoal?.data[0]?.author_employee_number === currEmpId) setDiaDelete(true);
        else toast.warning('Only author can delete.');
    };

    const handleDelete = () => {
        const payload = {
            coachingId: coachingMetricGoal?.data[0]?.coaching_metric_id,
            coachingItem: 'metric',
        };
        DeleteCoaching(payload)
        .unwrap()
        .then((res: any) => {
            if (res?.data) {
                toast.success('Metric Deleted successfully');
                setDiaDelete(false);
            } else {
                toast.error('Error Deleting Metric');
            }
        })
        .catch(() => {
            toast.error('Error Deleting Metric');
        });
    };

    const handleFormChange = (event: any) => {
        props.formChanged(true);
        const data = [...requestMetric];
        if (data?.length > 0) {
            data[0][event.target.name] = event.target.value;
            setRequestMetric(data);
        }
    };

    useEffect(() => {
        if (coachingMetricGoal?.data.length > 0) {
            setGoalCreationDate(new Date(coachingMetricGoal?.data[0]?.goal_create_date));
            setCoreValue(coachingMetricGoal?.data[0]?.core_value_id);
            setSkill(coachingMetricGoal?.data[0]?.coaching_skill_id);
            setBehavior(coachingMetricGoal?.data[0]?.coaching_behavior_id);
            props.setShowTLCpmment(
                coachingMetricGoal?.data[0]?.author_comment ||
                    (isUseCoachingSkills
                        ? coachingMetricGoal?.data[0]?.coaching_skill_id !== null ||
                          coachingMetricGoal?.data[0]?.coaching_behavior_id !== null
                        : coachingMetricGoal?.data[0]?.core_value_id !== null)
            );
            props.setShowAddGoal(
                coachingMetricGoal?.data[0]?.goal_comment || coachingMetricGoal?.data[0]?.next_month_goal
            );
            setCoachingMetricId(coachingMetricGoal?.data[0]?.coaching_metric_id);
            const metric = transformDataUpdateMetricForm(coachingMetricGoal);
            setRequestMetric(metric);
            setShowToDoButton(
                (coachingMetricGoal?.data[0]?.coaching_skill_id !== null &&
                    coachingMetricGoal?.data[0]?.coaching_behavior_id !== null) ||
                    !isUseCoachingSkills
            );
            // always show shoutout button
            setShowShoutOutButton(true);
        }
    }, [coachingMetricGoal]);

    useEffect(() => {
        props.handleCoreId(coreValue);
    }, [coachingMetricId, coreValue]);

    return (
        <>
            {props.showTLCpmment ? (
                <div className="logConversation mt-4 mb-4">
                    <Button
                        className="deleteBtnIcon p-button-outlined border-0 float-end me-3"
                        onClick={deleteIconClicked}
                    />
                    <div className="flex mb-3">
                        {isUseCoachingSkills === true ? (
                            <div className="col-md-10 mb-2 mt-1">
                                <SkillBehaviorDropdown
                                    fullWidth
                                    skill={skill}
                                    setSkill={setSkill}
                                    behavior={behavior}
                                    setBehavior={setBehavior}
                                    setSkillName={setSkillName}
                                    setBehaviorName={setBehaviorName}
                                />
                            </div>
                        ) : (
                            <div className="col-md-3 mb-2">
                                <CoreValueDropdown
                                    fullWidth
                                    coreValue={coreValue}
                                    setCoreValue={setCoreValue}
                                />
                            </div>
                        )}
                        <div className="me-2">
                            <DescriptionBox
                                title="Team Lead Comments"
                                value={requestMetric[0]?.authorComment}
                                responseDescription={requestMetric[0]?.authorComment}
                                limit={1000}
                                onChange={(value) => {
                                    const syntheticEvent = {
                                        target: { name: 'authorComment', value },
                                    };
                                    handleFormChange(syntheticEvent);
                                }}
                            />
                        </div>
                        <div className="d-flex justify-content-end gap-2 me-2">
                            {showToDoButton && (
                                <CoachingToDo
                                    receiverId={props.recipientId}
                                    receiverName={props.receiverName}
                                    visible={props.toDoVisible}
                                    setVisible={props.setToDoVisible}
                                    coachingEntityTypeId={4}
                                    coachingEntityId={coachingMetricId}
                                    coachingStatusId={1}
                                    todoTitle={todoTitle}
                                    skill={skill}
                                    behavior={behavior}
                                />
                            )}
                            {showShoutOutButton && (
                                <CoachingShoutOut
                                    receiverId={props.recipientId}
                                    receiverName={props.receiverName}
                                    visible={props.shoutoutVisible}
                                    setVisible={props.setShoutoutVisible}
                                    coachingEntityTypeId={4}
                                    coachingEntityId={coachingMetricId}
                                    coreValueId={props.coreValueId ?? 1}
                                />
                            )}
                        </div>
                    </div>
                </div>
            ) : (
                ''
            )}
            <div className="row">
                <div className="col-md-1">
                    <span>&nbsp;</span>
                </div>
                {props.showAddGoal ? (
                    <div className="col-md-11">
                        <div className="logConversation mt-4 mb-4">
                            <div className="flex mb-12">
                                <div className="col-12 me-2">
                                    <div className="row">
                                        <div className="col-md-3" style={{ display: 'none' }}>
                                            <div className="content">
                                                <h6>Creation Date</h6>
                                                <Calendar
                                                    id="basic"
                                                    disabled
                                                    value={goalCreationDate}
                                                    showIcon
                                                    className="custom-calendar mb-4"
                                                    dateFormat="dd-M-yy"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <DescriptionBox
                                        title="Agents Input"
                                        value={requestMetric[0]?.goalComment}
                                        responseDescription={requestMetric[0]?.goalComment}
                                        limit={1000}
                                        onChange={(value) => {
                                            const syntheticEvent = {
                                                target: { name: 'goalComment', value },
                                            };
                                            handleFormChange(syntheticEvent);
                                        }}
                                    />
                                    <p>Next Months Goal (Numeric) </p>
                                    <InputText
                                        name="nextMonthGoal"
                                        className="w-10 borderRadius8"
                                        value={requestMetric[0]?.nextMonthGoal}
                                        keyfilter={/^([/.0-9]|[/.0-9]?%)$/}
                                        onChange={(event) => handleFormChange(event)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    ''
                )}
            </div>
            {diaDelete && (
                <DeleteCoachingDialog
                    diaDelete={diaDelete}
                    setDiaDelete={setDiaDelete}
                    handleDelete={handleDelete}
                />
            )}
        </>
    );
};

export default MetricGoal;
